<template lang="pug">
	.web-services--output-ssml-template
		DxButton(:text="$tCaption('SSML template')", :type="output.SsmlTemplate ? 'default' : 'normal'" @click="show")
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :title="title", :height="600")
			.flex-col
				InsertionDetails(
					ref="details",
					:tracker="null",
					:track="null",
					slot="body",
					:item="ssmlTemplate",
					:getSsml="getSsml",
					:creativeIabCategories="[]",
					:templateFields="[]",
					:allowKeyEditing="false",
					:readonly="false",
					:hideVoiceSelection="true",
					:ssmlOnly="true",
					:predefinedUsedServices="servicesList",
					:preventContextMenuCustomProcess="true",
					@loadAudio="actionGenerateAudio",
					@stopAll="stop",
					@save="save",
					@cancel="cancel",
					@remove="() => cancel(true)",
				)
					template(slot="editor")
						.font-small.grey * {{$tCaption('Use [VALUE] (in square brackets) keyword to get output\'s value.')}}
			template(slot="actions-left")
				DxButton(:text="$tCaption('Clear', '@actions')", @click="clear")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false")
				DxButton(:text="$tCaption('Save', '@actions')", type="default", @click="save()")
</template>

<script>
import _ from 'lodash';
import DxButton from 'devextreme-vue/button';
import Popup from 'app-core/Popup.vue';
import InsertionDetails from '../insertion/Detail.vue';
import ssmlHelper from 'view/insertion/ssml-helper.js';
import json5 from 'json5';

export default {
	translationCategory: 'webServiceCaller.OutputSsmlTemplate',
	components: { DxButton, Popup, InsertionDetails },
	props: ['output', 'service'],
	data() {
		return {
			popupVisible: false,
			ssmlTemplate: {
				ssml: '[VALUE]'
			}
		};
	},
	computed: {
		title() {
			return this.$tCaption('SSML template: <OUTPUTNAME>').replace(/<OUTPUTNAME>/g, this.output?.Name);
		},
		servicesList() {
			return [this.service];
		}
	},
	watch: {
		
	},
	mounted() {
		
	},
	methods: {
		getSsml(record, ssml, isPreview) {
				if (__DEBUG__)
				console.debug('Get ssml', { record, ssml });
			if (!ssml) return null;

			let data = ssmlHelper.prepareSsml(ssml, { ...record, sender: this, isPreview });

			return isPreview ? data : data?.ssml;
		},
		async actionGenerateAudio() {

		},
		async stop() {

		},
		async cancel() {

		},
		show() {
			if (__DEBUG__)
				window.outputSsmlTemplate = this;
			if (this.output?.SsmlTemplate) {
				this.ssmlTemplate = this.output?.SsmlTemplate ? _.cloneDeep(this.output?.SsmlTemplate) : {
					ssml: '[VALUE]'
				}
			}
			this.popupVisible = false;
			setImmediate(() => this.popupVisible = true);
		},
		async save() {
			const record = this.$refs.details?.record || this.ssmlTemplate;
			if (__DEBUG__)
				console.debug('Save', { record });
			this.ssmlTemplate.ssml = record.ssml;
			this.$set(this.output, 'SsmlTemplate', this.ssmlTemplate?.ssml ? this.ssmlTemplate : null);
			this.processArrayCalculationConfig();
			this.popupVisible = false;
		},
		processArrayCalculationConfig() {
			const div = document.createElement('div');
			div.innerHTML = this.output.SsmlTemplate?.ssml;
			let servicesWithCurrentParam = div.querySelector(`adthos\\:wbs[outparam="${this.output.Name}"]`);
			this.$set(this.output, 'ArrayCalculationConfig', servicesWithCurrentParam && servicesWithCurrentParam.getAttribute('listoptions') ? json5.parse(servicesWithCurrentParam.getAttribute('listoptions')) : null);
		},
		clear() {
			this.$refs.details.record.ssml = '';
			this.$refs.details.ssml = '';
		}
	}
};
</script>
<style lang="scss">
	.web-services--output-ssml-template {
		
	}
</style>
